module.exports = __webpack_public_path__ + "static/media/property-marker.0690187c.svg";